import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=f8e20844"
import script from "./DateField.vue?vue&type=script&lang=js"
export * from "./DateField.vue?vue&type=script&lang=js"
import style0 from "./DateField.vue?vue&type=style&index=0&id=f8e20844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.102.0__lodash@4_9e7f287e1541e9ab10d10bde1bb44969/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports